import { YITagGroupPathRelativePath } from './types'

export function generateTagGroupPath ({
  tagGroupRelativePath,
}: {
  tagGroupRelativePath: YITagGroupPathRelativePath
}) {
  // Both en and es tags are attached to EN tag-group
  const path = `yoga-international/en/tag-group/${tagGroupRelativePath}`
  return path
}
